module.exports = __webpack_public_path__ + "static/media/auto-rickshaw-04.fa03426f.svg";